import { Button, useTheme } from '@ytl/common-web';
import { useLayoutEffect } from 'react';
import { ReactComponent as PageNotFoundIcon2 } from '../../../../assets/PageNotFound2.svg';
import { useLanguage } from '../../../../contexts/languageContext';
import { getConfig } from '../../../data/config';

export const NoSubscriberFound = () => {
  const { translation } = useLanguage();
  const { isWebView } = useTheme();

  useLayoutEffect(() => {
    document.documentElement.classList.add('banned-screen');
    return () => {
      document.documentElement.classList.remove('banned-screen');
    };
  }, []);

  const handleAppointmentClick = () => {
    const appointmentUrl = getConfig().appointmentBookingUrl;
    if (appointmentUrl) {
      if (isWebView) {
        window.location.href = appointmentUrl;
      } else {
        window.open(appointmentUrl, '_blank');
      }
    } else {
      console.warn('appointmentBookingUrl nincs konfigurálva');
    }
  };

  const handleBackToHomepage = () => {
    window.location.href = getConfig().closeWebViewUrl;
    return;
  };

  return (
    <div className={`verification-step__banned${isWebView ? ' verification-step__banned--webview' : ''}`}>
      {!isWebView && (
        <div
          className={`verification-step__banned__illustration${isWebView ? ' verification-step__banned__illustration--webview' : ''}`}
        >
          <PageNotFoundIcon2 />
        </div>
      )}
      <div
        className={`verification-step__banned__content${isWebView ? ' verification-step__banned__content--webview' : ''}`}
      >
        <h2 className="onboarding-step__header">{translation.onboarding?.selectSubscriber?.noSubscriber}</h2>
        <p
          className="onboarding-step__description"
          dangerouslySetInnerHTML={{
            __html: isWebView
              ? translation.onboarding.selectSubscriber.failedDescriptionApp
              : translation.onboarding.selectSubscriber.failedDescription,
          }}
        />
        <div
          className={`verification-step__banned__actions${isWebView ? ' verification-step__banned__actions--webview' : ''}`}
        >
          <Button
            variant="contained"
            onClick={handleBackToHomepage}
          >
            {translation.onboarding?.selectSubscriber?.backToLoginApp}
          </Button>
          <Button
            variant="outlined"
            onClick={handleAppointmentClick}
          >
            {translation.onboarding?.selectSubscriber?.reserve}
          </Button>
        </div>
      </div>
    </div>
  );
};
